<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-10">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a [routerLink]="['/home']">Home</a></li>
      <li class="breadcrumb-item"><a [routerLink]="['/smart-irrigation/regions']">Regions</a></li>
      <li class="breadcrumb-item active"><strong>{{ scopedParkName || 'Parks' }}</strong></li>
    </ol>
  </div>
  <div class="col-lg-2 d-flex align-items-center justify-content-end gap-2">
    <small class="text-muted" *ngIf="lastRefresh">{{ lastRefresh | date:'d MMM yyyy HH:mm' }}</small>
    <button class="btn btn-outline-white btn-sm" (click)="refresh()" [disabled]="loading" title="Refresh">
      <i class="fa fa-sync" [class.fa-spin]="loading"></i>
    </button>
  </div>
</div>

<div class="wrapper wrapper-content animated fadeInRight pt-3">
  <div class="alert alert-info" *ngIf="loading">
    <i class="fa fa-spinner fa-spin me-2"></i> Loading parks&hellip;
  </div>

  <ng-container *ngIf="!loading">
    <div class="alert alert-secondary" *ngIf="parks.length === 0">
      No parks containing irrigation controllers found.
    </div>

    <div class="parks-grid" *ngIf="parks.length > 0">
      <section class="park-card" *ngFor="let park of parks">
        <div class="park-card__header">
          <div>
            <div class="park-card__name">{{ park.name }}</div>
            <div class="park-card__summary">{{ park.controllerCount }} Irrigation Controller{{ park.controllerCount === 1 ? '' : 's' }}</div>
          </div>
          <i class="fa fa-tree park-card__icon" aria-hidden="true"></i>
        </div>
        <div class="park-alarm-warning" *ngIf="park.activeAlarmCount > 0" role="alert">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          {{ park.activeAlarmCount }} active controller alarm{{ park.activeAlarmCount === 1 ? '' : 's' }}
        </div>
        <div class="park-weather" *ngIf="park.weatherMetrics.length > 0">
          <div class="park-weather__metric" *ngFor="let metric of park.weatherMetrics" [ngClass]="'park-weather__metric--' + metric.status"
            (click)="viewWeatherTrend(park)" role="button" tabindex="0"
            (keydown.enter)="viewWeatherTrend(park)" [attr.aria-label]="'View ' + metric.label + ' trend for ' + park.name"
            [title]="metric.stationName + ' | URI: ' + metric.stationUri">
            <span class="park-weather__label">{{ metric.label }}</span>
            <strong class="park-weather__value">{{ metric.value }}<small> {{ metric.unit }}</small></strong>
          </div>
        </div>
        <div class="park-water-meter" *ngIf="park.waterMeter as meter" (click)="viewWaterUsage(park)" role="button" tabindex="0"
             (keydown.enter)="viewWaterUsage(park)" [attr.aria-label]="'View water usage trend for ' + park.name">
          <div class="park-water-meter__header">
            <span class="park-water-meter__title">Water Usage</span>
            <span class="park-water-meter__value" *ngIf="meter.usage != null && meter.allocation != null">
              {{ meter.usage | number:'1.0-2' }} / {{ meter.allocation | number:'1.0-2' }} kL
            </span>
            <span class="park-water-meter__value" *ngIf="meter.usage != null && meter.allocation == null">
              {{ meter.usage | number:'1.0-2' }} kL
            </span>
            <span class="park-water-meter__value" *ngIf="meter.usage == null">No usage data</span>
          </div>
          <div class="park-water-meter__bar" *ngIf="meter.usagePercentage != null" role="progressbar"
               [attr.aria-valuenow]="meter.usagePercentage" aria-valuemin="0" aria-valuemax="100"
               [attr.aria-label]="'Water usage: ' + (meter.usagePercentage | number:'1.0-0') + ' percent of allocation'">
            <div class="park-water-meter__bar-fill" [ngClass]="'park-water-meter__bar-fill--' + meter.barColor"
                 [style.width.%]="meter.usagePercentage > 100 ? 100 : meter.usagePercentage"></div>
          </div>
          <div class="park-water-meter__percent" *ngIf="meter.usagePercentage != null"
               [ngClass]="'park-water-meter__percent--' + meter.barColor">
            {{ meter.usagePercentage | number:'1.0-0' }}% of seasonal allocation
          </div>
        </div>
        <div class="park-tank-level" *ngIf="park.tankLevel as tank">
          <div class="park-tank-level__header">
            <span class="park-tank-level__title">Tank Level</span>
            <span class="park-tank-level__value">{{ tank.percentage | number:'1.0-0' }}%</span>
          </div>
          <div class="park-tank-level__bar" role="progressbar"
               [attr.aria-valuenow]="tank.percentage" aria-valuemin="0" aria-valuemax="100"
               [attr.aria-label]="'Tank level: ' + (tank.percentage | number:'1.0-0') + ' percent'">
            <div class="park-tank-level__bar-fill" [ngClass]="'park-tank-level__bar-fill--' + tank.barColor"
                 [style.width.%]="tank.percentage"></div>
          </div>
        </div>
        <div class="park-children">
          <div class="park-child" *ngFor="let child of park.children" [ngClass]="['park-child--' + child.status, child.controllerCount === 0 ? 'park-child--inactive' : '']"
               (click)="viewChild(child)" [attr.role]="child.controllerCount > 0 ? 'button' : null"
            [attr.tabindex]="child.controllerCount > 0 ? 0 : null" (keydown.enter)="child.controllerCount > 0 && viewChild(child)">
            <div class="park-child__icon" [ngClass]="child.irrigationActive ? 'park-child__icon--active' : 'park-child__icon--inactive'"
                 [title]="child.irrigationActive === true ? 'Irrigation currently active' : 'Irrigation not currently active or unavailable'"
                 aria-hidden="true">
              <i class="fa fa-tint"></i>
            </div>
            <div class="park-child__content">
              <div class="park-child__header">
                <strong>{{ child.name }}</strong>
                <span class="park-child__status">{{ child.status }}</span>
              </div>
              <div class="park-child__stats">
                <span><strong>{{ child.controllerCount }}</strong> Controllers</span>
                <span><strong>{{ child.sensorCount }}</strong> Sensors</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </ng-container>
</div>
